import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { numberFormatterInternational } from '../../../../app/utils/telephonyHelpers';
import * as conversationActions from '../../../conversation/actions/conversation';
import { notificationActions } from '../../../notifications/actions/notification';
import * as telephonyActions from '../../../telephony/actions/telephony';
import { transferToAgentActions } from '../actions/transferToAgentModal';
import * as transferToAgentAPI from '../api/transferToAgent';
const { conversationWsClose, conversationWsAgentUnassigned } = conversationActions.actions;
const { telephonyResetHold } = telephonyActions.actions;
const { notificationAdd, notificationRemoveByType } = notificationActions;
const { transferToAgentAssistedRequest, transferToAgentAssistedRequestSucceeded, transferToAgentAssistedRequestFailed, transferToAgentBlindRequest, transferToAgentBlindRequestSucceeded, transferToAgentBlindRequestFailed, transferToAgentAssistedResolve, transferToAgentAssistedResolveSucceeded, transferToAgentAssistedResolveFailed, transferToAgentRequestStop, transferToAgentModalClose, transferToAgentHideMessageModal, transferToAgentWsTransferAnswered, } = transferToAgentActions;
export const transferToAgentModal = [
    takeEvery(transferToAgentAssistedRequest.toString(), apiGenWithPromise(transferToAgentAPI.assistedTransferRequest, transferToAgentAssistedRequestSucceeded, transferToAgentAssistedRequestFailed)),
    takeEvery(transferToAgentBlindRequest.toString(), apiGenWithPromise(transferToAgentAPI.blindTransferRequest, transferToAgentBlindRequestSucceeded, transferToAgentBlindRequestFailed)),
    takeEvery(transferToAgentAssistedResolve.toString(), apiGenWithPromise(transferToAgentAPI.assistedTransferResolve, transferToAgentAssistedResolveSucceeded, transferToAgentAssistedResolveFailed)),
    takeLatest(conversationWsClose.toString(), conversationCloseGen),
    takeEvery(conversationWsAgentUnassigned.toString(), conversationWsAgentUnassignedGen),
    takeEvery(transferToAgentWsTransferAnswered.toString(), transferToAgentAnswered),
    takeEvery(transferToAgentAssistedRequestSucceeded.toString(), transferToAgentRequestSucceededHandler),
    takeEvery(transferToAgentAssistedRequestFailed.toString(), transferToAgentRequestFailedHandler),
    takeEvery(transferToAgentAssistedResolveSucceeded.toString(), transferToAgentResolveSucceededHandler),
];
function apiGenWithPromise(apiCall, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiCall, action.payload);
            result.meta.request = action.payload;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction({ action: action, result: result }));
        }
    };
}
// Unassign conversation.
export function* conversationWsAgentUnassignedGen(action) {
    const newAgent = action.payload.agent;
    const csid = action.payload.csid;
    const getConversations = (state) => state.conversations;
    const conversationsState = yield select(getConversations);
    const foundMetaConversation = conversationsState.metaConversations.find((metaC) => metaC.conversation.id === csid);
    if (foundMetaConversation) {
        const getTransferToAgent = (state) => state.transferToAgent;
        const transferToAgentState = yield select(getTransferToAgent);
        yield put(transferToAgentModalClose());
        yield put(transferToAgentHideMessageModal());
        const foundTransferRequest = transferToAgentState.transferRequests.find((request) => request.metaConversation.conversation.id === csid);
        if (foundTransferRequest && newAgent) {
            yield put(transferToAgentRequestStop({ csid: csid }));
        }
    }
}
// Closed conversation.
export function* conversationCloseGen(action) {
    const csid = action.payload.params.csid;
    const getConversations = (state) => state.conversations;
    const conversationsState = yield select(getConversations);
    // Check if our current conversation in conversation view is the conversation that got closed.
    const foundMetaConversation = conversationsState.metaConversations.find((metaC) => metaC.conversation.id === csid);
    if (foundMetaConversation) {
        const getTransferToAgent = (state) => state.transferToAgent;
        const transferToAgentState = yield select(getTransferToAgent);
        yield put(transferToAgentModalClose());
        yield put(transferToAgentHideMessageModal());
        yield put(notificationRemoveByType({ type: `transfer_assisted_option_${csid}` })); // Close any transfer assisted option notification.
        const foundTransferRequest = transferToAgentState.transferRequests.find((request) => request.metaConversation.conversation.id === csid);
        if (foundTransferRequest) {
            yield put(notificationRemoveByType({ type: `conversation_closed_${csid}` }));
            let author = null;
            let name = null;
            if (foundMetaConversation.conversation.authors &&
                foundMetaConversation.conversation.authors[action.payload.params.closed_by]) {
                author =
                    foundMetaConversation.conversation.authors[action.payload.params.closed_by];
                if (author.name) {
                    name = author.name;
                }
                else if (author.phone_number) {
                    name = numberFormatterInternational({
                        phoneAgent: author.phone_number,
                    });
                }
                else if (author.email) {
                    name = author.email;
                }
            }
            const notificationOption = {
                type: `conversation_closed_${csid}`,
                title: 'Conversation was closed',
                text: `${csid} was closed ` + (name ? `by ${name}` : ''),
                className: 'default',
                icon: 'i-info',
            };
            yield put(notificationAdd(notificationOption));
            yield put(transferToAgentRequestStop({ csid: csid }));
        }
    }
}
export function* transferToAgentAnswered(action) {
    const { csid, accepted } = action.payload.params;
    const getConversations = (state) => state.conversations;
    const conversationsState = yield select(getConversations);
    // Check if our current conversation in conversation view is the conversation that got closed.
    const foundMetaConversation = conversationsState.metaConversations.find((metaC) => metaC.conversation.id === csid);
    // Check that it's a conversation you are assigned to.
    if (foundMetaConversation && foundMetaConversation.isAssignedToMe === true) {
        // Remove the "trying to connect to agent" notification
        yield put(notificationRemoveByType({ type: `transfer_assisted_option_${csid}` }));
        if (accepted) {
            const acceptObj = {
                text: 'Complete transfer',
                action: function* () {
                    yield put(notificationRemoveByType({
                        type: `transfer_assisted_option_${csid}`,
                    }));
                    yield put(transferToAgentAssistedResolve({
                        metaConversation: foundMetaConversation,
                        accepted: true,
                    }));
                },
            };
            const rejectObj = {
                text: 'Take back',
                action: function* () {
                    yield put(notificationRemoveByType({
                        type: `transfer_assisted_option_${csid}`,
                    }));
                    yield put(transferToAgentAssistedResolve({
                        metaConversation: foundMetaConversation,
                        accepted: false,
                    }));
                },
            };
            const notificationOptions = {
                title: 'Transfer in progress',
                text: 'Do you want to complete the transfer?',
                type: 'transfer_assisted_option_' + csid,
                icon: 'i-users',
                leftAction: acceptObj,
                rightAction: rejectObj,
                closeAction: rejectObj.action,
                showDesktop: true,
                mainAction: {
                    navigate: `/dashboard`,
                },
            };
            yield put(notificationAdd(notificationOptions));
        }
    }
}
export function* transferToAgentRequestSucceededHandler(action) {
    const csid = action.payload.data.csid;
    const getConversations = (state) => state.conversations;
    const conversationsState = yield select(getConversations);
    // Check if our current conversation in conversation view is the conversation that got closed.
    const foundMetaConversation = conversationsState.metaConversations.find((metaC) => metaC.conversation.id === csid);
    if (foundMetaConversation) {
        const rejectObj = {
            text: 'Take back',
            action: function* () {
                yield put(notificationRemoveByType({
                    type: `transfer_assisted_option_${csid}`,
                }));
                yield put(transferToAgentAssistedResolve({
                    metaConversation: foundMetaConversation,
                    accepted: false,
                }));
            },
        };
        const notificationOptions = {
            title: 'Contacting agent',
            text: "You can take back the call if the agent doesn't reply",
            type: 'transfer_assisted_option_' + csid,
            icon: 'i-users',
            rightAction: rejectObj,
            closeAction: rejectObj.action,
            showDesktop: true,
            mainAction: {
                navigate: `/dashboard`,
            },
        };
        yield put(notificationAdd(notificationOptions));
    }
}
function* transferToAgentRequestFailedHandler(action) {
    var _a;
    const csid = action.payload.action.payload.metaConversation.conversation.id;
    const requestToUser = action.payload.action.payload.requestToUser;
    const name = (_a = requestToUser.name) !== null && _a !== void 0 ? _a : 'The agent';
    yield put(transferToAgentRequestStop({ csid }));
    const notificationOptions = {
        title: 'Transfer to agent failed',
        text: `${name} is not available to handle this transfer, try again later.`,
        icon: 'i-info',
        showDesktop: true,
        mainAction: {
            navigate: `/dashboard`,
        },
    };
    yield put(transferToAgentHideMessageModal());
    yield put(transferToAgentModalClose());
    yield put(notificationAdd(notificationOptions));
}
export function* transferToAgentResolveSucceededHandler(action) {
    const { csid, accepted } = action.payload.data;
    let notificationOptions;
    if (accepted) {
        notificationOptions = {
            type: 'transfer_resolved_' + csid,
            title: `Transfer completed`,
            text: `You are no longer assigned to #${csid}.`,
            className: 'success',
            showDesktop: true,
            mainAction: {
                navigate: `/conversation/${csid}`,
            },
            icon: 'i-info',
            time: 15000,
        };
    }
    else {
        yield put(telephonyResetHold());
        notificationOptions = {
            type: 'transfer_resolved_' + csid,
            title: `Transfer take back`,
            text: `You are again assigned to #${csid}.`,
            className: 'info',
            showDesktop: true,
            mainAction: {
                navigate: `/conversation/${csid}`,
            },
            icon: 'i-info',
            time: 15000,
        };
    }
    yield put(notificationAdd(notificationOptions));
}
